import React, { useContext } from 'react';
import { User } from 'firebase/auth';

export const AuthContext = React.createContext<
  | {
      readonly user: User | null;
      readonly isLoggedIn: boolean | null;
      readonly isLoading: boolean;
    }
  | undefined
>(undefined);

export const useCurrentAuthSession = () => {
  const value = useContext(AuthContext);

  if (!value) {
    throw new Error(
      'Cannot find provider. Did you forget to wrap using AuthProvider?',
    );
  }

  return value;
};
